//import { customHistory } from 'Components/RouterHistory'
import React from 'react'
import { createContext, useContext, useState } from "react"
//import { useNavigate } from "react-router-dom"

//import { useNavigateBack } from 'Components/useNavigateBack'
const UserContext  = createContext(null)

export const UserProvider = ({ initialState, children }) => {

    const [ user       , setUser        ] = useState(initialState)
    const [ progress   , setProgress    ] = useState(0)
    const [ loading    , setLoading     ] = useState(false)
    const [ isRedirect , setIsRedirect  ] = useState(false)
    const [ currentPath, setCurrentPath ] = useState('')
    
    const onChange = event => {
        
        setUser( prevState => ({
            ...prevState, [event.target.name]: event.target.value,
        }))
    }

    return (
        <UserContext.Provider value={{ 
            user, setUser, 
            progress, setProgress, 
            loading, setLoading, 
            onChange, isRedirect,
            setIsRedirect, currentPath, 
            setCurrentPath
        }} >
            {children}
        </UserContext.Provider>
    )
} 

export const useUser = () => useContext(UserContext)
